import {
  PROCESSING_ORDER_STATUS,
  PAYMENT_WAITING_ORDER_STATUS,
  IN_PRODUCTION_ORDER_STATUS,
  ON_HOLD_ORDER_STATUS,
  COMPLETED_ORDER_STATUS,
  PACKAGING_ORDER_STATUS,
  SHIPPING_ORDER_STATUS,
  ON_WAY_ORDER_STATUS,
} from '@/constants/order_statuses.js'
import {
  PROCESSING_INVOICE_STATUS,
  PAID_INVOICE_STATUS,
} from '@/constants/invoice_statuses.js'

// USA
export const locale = {
  GENERAL: {
    BACK_TO_TOP: 'Жогорууга кайтуу',
    IMPORTANT: 'Маанилүү',
    SELECT: 'Тандоо',
    PREVIOUS: 'Мурунку',
    NEXT: 'Кийинки',
    DELETE: 'Өчүрүү',
    OK: 'ОК',
    ATTENTION: 'Көңүл буруңуз!',
    FAQ: 'Көп берилген суроолор',
    BACK_HOME: 'БАШКЫ БЕТКЕ КАЙТУУ',
    REPLAY: 'КАЙРА ОЙНОТУУ',
    ACCEPT_ALL: 'Баарын кабыл алуу',
    CLOSE: 'Жабуу',
    LEARN_MORE: 'Толугураак билүү',
    MESSAGE_SEND: 'Билдирүү ийгиликтүү жөнөтүлдү',
    SEND: 'Жөнөтүү',
    SEND_US_EMAIL: 'Бизге электрондук кат жөнөтүңүз',
    SIZE: 'Өлчөмү',
    REPEAT: 'Кайталоо',
  },
  STORE: {
    SEARCH_TITLE: 'Издеп жаткан продукттарды көрүү үчүн жазып баштаңыз.',
    WELCOME: 'TUMARга кош келиңиз',
    GEOLOCATION:
      'Туура продукттар, баалар жана жеткирүү эсептөөлөрүн көрсөтүү үчүн геолокацияны колдонобуз',
    ENABLE_LOCATION: 'Улантуу үчүн геолокацияны иштетип коюңуз',
    GO_STORE: 'Дүкөнгө өтүү',
    IMPORTANT_GEOLOCATION_WARNING:
      'Сизге туура продукттарды жана бааларды берүү үчүн геолокация абдан маанилүү. Геолокациясыз улантууга ишеничтүүсүзбү?',
    NO_CONTENT: 'Бул бетте мазмун жок',
    WORKSHOPS: 'УСТАКАНАЛАР',
    ADD_TO_CART: 'СЕПЕТКЕ КОШУУ',
    SALE: 'Жеңилдик',
  },
  NOT_FOUND: {
    PAGE_NOT_FOUND: 'Кечиресиз, бул баракча табылган жок',
    LINK: 'Ссылка сизге жеткиликтүү болбошу мүмкүн',
    REMOVED: 'же баракча өчүрүлгөн болушу мүмкүн.',
  },
  REVIEW: {
    LEAVE_REVIEW: 'Пикир калтыруу',
    HOW_RATE: 'Кантип баалайт элеңиз?',
    REVIEW_TEXT: 'Пикирдин тексти',
    RATE_US: 'Бизди баалаңыз',
    SUBMIT_REVIEW: 'Пикир жөнөтүү',
    REVIEW_VERIFIED:
      'Бардык пикирлер 48 саат ичинде текшерилет, аныктыгы жана тууралыгы камсыз кылынат.',
    OUR_REVIEWS: 'БИЗДИН ПИКИРЛЕР',
    YOUR_OPINION:
      'Сиздин оюңуз биз үчүн маанилүү! Эгер биздин продукттар боюнча пикир бөлүшкүңүз келсе же сын калтыргыңыз келсе, биз кубанычтабыз. Бул бизди жакшыртууга жардам берет. Бизди тандаганыңыз үчүн рахмат!',
    WRITE_REVIEW: 'Пикир жазуу',
    REPLAY_TO_REVIEW: 'Пикирге жооп берүү',
  },
  BASKET: {
    SPEACIAL_ITEM:
      'Сиздин себетиңизде атайын буюм бар. Башка буюмдарды сатып алуу үчүн бул сатып алууну бүтүрүүңүз керек.',
  },
  COOKIE: {
    TITLE: 'Cookies колдонууга макулдук берүү',
    ACCEPT:
      '«Бардык cookies кабыл алуу» баскычын басуу менен, Stack Exchange сиздин түзмөгүңүзгө cookies сактоого жана маалыматты бөлүшүүгө макулдук бересиз',
    POLICY: 'Cookies саясаты',
  },
  CHAT_BOT: {
    TITLE: 'Tumar чат-бот',
    SUBTITLE: 'Суроолорго жооптор',
  },
  TRANSLATOR: {
    SELECT: 'Тилиңизди тандаңыз',
  },
  MENU: {
    NEW: 'жаңы',
    ACTIONS: 'Аракеттер',
    CREATE_POST: 'Жаңы пост түзүү',
    PAGES: 'Барактар',
    FEATURES: 'Функциялар',
    APPS: 'Тиркемелер',
    DASHBOARD: 'Башкаруу панели',
  },
  REYESTR_MENU: [
    {
      title: 'Main',
      icon: '/img/icons/Home.svg',
      to: 'Admin home',
      disabled: false,
    },
    {
      title: 'Profile',
      icon: '/img/icons/Document.svg',
      to: 'profile',
      disabled: false,
    },
    {
      title: 'Order history',
      icon: '/img/icons/Folder.svg',
      disabled: false,
      to: 'order history',
      subLinks: [],
    },
    {
      title: 'Retail Order History',
      icon: '/img/icons/Folder.svg',
      disabled: false,
      to: 'retail order history',
      subLinks: [],
    },
    {
      title: 'Invoice',
      icon: '/img/icons/Paper.svg',
      to: 'invoice orders',
      disabled: false,
    },
    {
      title: 'Messages',
      icon: '/img/icons/Group.svg',
      to: 'chat',
      disabled: false,
    },
    {
      title: 'Price list',
      icon: '/img/icons/Group.svg',
      to: 'price list',
      disabled: false,
    },
    {
      title: 'Reyestr',
      icon: '/img/icons/Group.svg',
      to: 'reyestr',
      disabled: false,
    },
  ],
  RETAIL_MENU: [
    {
      title: 'Messages',
      icon: '/img/icons/Group.svg',
      to: 'chat',
      disabled: false,
    },
    {
      title: 'Profile',
      icon: '/img/icons/Document.svg',
      to: 'profile',
      disabled: false,
    },
    {
      title: 'Retail Order History',
      icon: '/img/icons/Folder.svg',
      disabled: false,
      to: 'retail order history',
      subLinks: [],
    },
  ],
  SEARCH: {
    SEARCH_KEYWORDS: 'Издөө үчүн ачкыч сөздөр...',
    SEARCH: 'Издөө',
  },
  GROUPS: 'Топтор',
  PRICE_TITLE: 'Баасы',
  SELE_CTED_GROUP: 'Бардыгы',
  DROPDOWN: {
    items: ['Бардыгы', 'Эркектер', 'Аялдар', 'Балдар', 'Унисекс'],
  },
  FILTERS: {
    groups: {
      male: false,
      female: false,
      children: false,
      unisex: false,
    },
    'production technique': {
      'solid-rolled': false,
      stitched: false,
    },
    model: {
      slippers: false,
      boots: false,
    },
  },
  FILTER_KEYS: {
    groups: 'groups',
    production_technique: 'тproduction technique',
    model: 'model',
  },
  AUTH: {
    GENERAL: {
      OR: 'Же',
      SUBMIT_BUTTON: 'Жөнөтүү',
      NO_ACCOUNT: 'Аккаунтуңуз жокпу?',
      SIGNUP_BUTTON: 'Катталуу',
      FORGOT_BUTTON: 'Сырсөз унутулду',
      BACK_BUTTON: 'Артка',
      PRIVACY: 'Купуялык',
      LEGAL: 'Юридикалык маалымат',
      CONTACT: 'Байланыш',
    },
    LOGIN: {
      TITLE: 'Аккаунтка кирүү',
      BUTTON: 'Кирүү',
    },
    FORGOT: {
      TITLE: 'Сырсөздү унуттуңузбу?',
      DESC: 'Сырсөздү калыбына келтирүү үчүн электрондук почтаңызды киргизиңиз',
      SUCCESS: 'Сырсөз ийгиликтүү калыбына келтирилди.',
    },
    REGISTER: {
      TITLE: 'Катталуу',
      DESC: 'Аккаунтуңузду түзүү үчүн маалыматтарды киргизиңиз',
      SUCCESS: 'Аккаунтуңуз ийгиликтүү катталды.',
    },
    LOGOUT: 'Чыгуу',
    INPUT: {
      EMAIL: 'E-mail',
      FULLNAME: 'Толук аты',
      PASSWORD: 'Сырсөз',
      CONFIRM_PASSWORD: 'Сырсөздү тастыктоо',
      USERNAME: 'Колдонуучу аты',
    },
    VALIDATION: {
      INVALID: '{{name}} жараксыз',
      REQUIRED: '{{name}} талап кылынат',
      MIN_LENGTH: '{{name}} минималдуу узундугу {{min}}',
      AGREEMENT_REQUIRED: 'Шарттарды кабыл алуу талап кылынат',
      NOT_FOUND: '{{name}} табылган жок',
      INVALID_LOGIN: 'Кирүү маалыматтары туура эмес',
      REQUIRED_FIELD: 'Бул талаа талап кылынат',
      MIN_LENGTH_FIELD: 'Минималдуу узундук:',
      MAX_LENGTH_FIELD: 'Максималдуу узундук:',
      INVALID_FIELD: 'Талаа жараксыз',
    },
  },
  ECOMMERCE: {
    COMMON: {
      SELECTED_RECORDS_COUNT: 'Тандалган жазуулардын саны: ',
      ALL: 'Бардыгы',
      SUSPENDED: 'Токтотулган',
      ACTIVE: 'Активдүү',
      FILTER: 'Фильтр',
      BY_STATUS: 'Статус боюнча',
      BY_TYPE: 'Түрү боюнча',
      BUSINESS: 'Бизнес',
      INDIVIDUAL: 'Жеке',
      SEARCH: 'Издөө',
      IN_ALL_FIELDS: 'бардык талаалар боюнча',
    },
    ECOMMERCE: 'Электрондук соода',
    CUSTOMERS: {
      CUSTOMERS: 'Кардарлар',
      CUSTOMERS_LIST: 'Кардарлардын тизмеси',
      NEW_CUSTOMER: 'Жаңы кардар',
      DELETE_CUSTOMER_SIMPLE: {
        TITLE: 'Кардарды өчүрүү',
        DESCRIPTION: 'Бул кардарды түбөлүк өчүрүүгө ишенесизби?',
        WAIT_DESCRIPTION: 'Кардар өчүрүлүүдө...',
        MESSAGE: 'Кардар өчүрүлдү',
      },
      DELETE_CUSTOMER_MULTY: {
        TITLE: 'Кардарларды өчүрүү',
        DESCRIPTION: 'Тандалган кардарларды түбөлүк өчүрүүгө ишенесизби?',
        WAIT_DESCRIPTION: 'Кардарлар өчүрүлүүдө...',
        MESSAGE: 'Тандалган кардарлар өчүрүлдү',
      },
      UPDATE_STATUS: {
        TITLE: 'Тандалган кардарлардын статусу жаңыртылды',
        MESSAGE: 'Статус ийгиликтүү жаңыртылды',
      },
      EDIT: {
        UPDATE_MESSAGE: 'Кардар жаңыртылды',
        ADD_MESSAGE: 'Кардар түзүлдү',
      },
    },
  },
  HEADER: {
    GO_TO_STORE: 'GO TO THE STORE',
    CON_TACTS: 'Contacts',
  },
  MAIN: {
    h1: 'Welcome',
    tumar: 'Tumar',
    logout: 'Log out',
    info: {
      1: 'From your account dashboard you can view your',
      2: 'recent orders',
      3: 'manage your',
      4: 'shipping and billing addresses',
      5: 'and',
      6: 'edit your password and account details.',
    },
  },
  PROFILE: {
    balance: 'Сиздин балансыңыз',
    order_details: 'Заказдын деталдары',
    settings_title: 'Жөндөөлөр',
    user_title: 'Колдонуучу',
    edit_user: 'Колдонуучуну түзөтүү',
    user_form: [
      'Аты',
      'Фамилиясы',
      'Чагылдырылуучу аты',
      'Электрондук почта дареги',
      'Ролу',
      'Сырсөз',
    ],
    change_password: 'Сырсөздү алмаштыруу',
    password_change_form: [
      'Учурдагы сырсөз (өзгөртпөсөңүз бош калтырыңыз)',
      'Жаңы сырсөз (өзгөртпөсөңүз бош калтырыңыз)',
      'Жаңы сырсөздү тастыктоо',
    ],
    save_password: 'Өзгөртүүлөрдү сактоо',
    add: 'Кошуу',
    delete: 'Өчүрүү',
    edit: 'Түзөтүү',
    user: ['Колдонуучу', 'Электрондук почта', 'Ролу', 'Аракеттер', ''],
  },
  INVOICE: {
    orders: {
      total_balance: 'Сиздин балансыңыз',
      table_header: [
        'Заказ номери',
        'Жыйынтыгы',
        'Эсеп-фактура',
        'Эсеп-фактуранын суммасы',
        'Статусу',
        'Төлөнгөн сумма',
        'Баланс',
        '&nbsp;',
      ],
      view: 'Кароо',
    },
    invoices: {
      order_number: 'Заказ номери',
      invoice_table: [
        'Эсеп-фактура номери',
        'Датасы',
        'Статусу',
        'Жалпы сумма',
        'Эсеп-фактуранын суммасы',
        'Аракеттер',
      ],
      view: 'Кароо',
      statuses: {
        [PROCESSING_INVOICE_STATUS]: 'Иштеп жатат',
        [PAID_INVOICE_STATUS]: 'Төлөндү',
      },
    },
  },
  BRENDING: {
    price: 'Баасы',
    choosePrice: 'Бааны тандаңыз',
    brending_text: 'Брендинг',
    pre_count: 'Тандалган буюмдардын алдын ала саны',
    colors: 'Түстөр',
    add_to_cart: 'Сепетке кошуу',
    size: 'Өлчөмү',
    brending_body: {
      place: 'Жайгаштыруу',
      price_unchangable: 'Баасы өзгөртүлбөйт',
      price_changable: 'Баасы өзгөртүлөт',
      replace: 'Алмаштыруу',
      delete: 'Өчүрүү',
    },
  },
  PRODUCT_DESCRIPTION: {
    sole: 'Табан',
    branding: 'Брендинг',
    table: {
      image: 'сүрөт',
      details: 'деталдары',
      price: 'баасы',
      color: 'түсү',
      size: 'өлчөмү',
      count: 'саны',
      total: 'жалпы',
      pre_count: 'алдын ала саны',
      order_details: 'заказдын деталдары',
    },
    second_table: {
      totalCount: 'жалпы саны',
      sum: 'жыйынтык сумма',
      discount: 'жеңилдик',
      saving: 'үнөмдөө',
      delivery: 'жеткирүү',
      total: 'жалпы',
      saved: 'үнөмдөлдү',
    },
    go_to_order: 'заказга өтүү',
    notes: 'Продукцияга логотипти колдонуу деталдары кийин чат аркылуу берилет',
    logo_place: 'Логотип үчүн орун',
    order_details: 'Заказ тууралуу маалымат',
  },
  REGISTRATION: {
    my_order: 'Менин заказым',
    payment_info: 'Төлөм маалыматы',
    first_name: 'Аты',
    last_name: 'Фамилиясы',
    number: 'Номери',
    email: 'Электрондук почта дареги',
    delivery_adress: 'Жеткирүү дарегин киргизиңиз',
    country: 'Өлкө',
    countries: ['Россия', 'Украина', 'Кыргызстан', 'Казакстан', 'Беларусь'],
    address: 'Дарек',
    home_number: 'Үй номери жана көчөнүн аты',
    locality: 'Жердин аталышы',
    region: 'Регион',
    postcode: 'Индекс',
    inn: 'ИНН',
    your_order: 'Сиздин заказ',
    coupon_code: 'ЭГЕР КУПОН КОДУҢУЗ БАР БОЛСО ТӨМӨНДӨ КОЛДОНУҢУЗ',
    coupon_placeholder: 'Промокод / арзандатуу картасынын номери барбы?',
    apply_coupon: 'КУПОНДУ КОЛДОНУУ',
    product: 'Продукт',
    subtotal: 'Жалпы сумма',
    shipping: 'Жеткирүү',
    total: 'Жалпы',
    rule: 'Заказ берүү менен сиз биздин [get_rules], [get_politica_konf] жана [get_return_and_exchange] шарттарын кабыл аласыз. Ошондой эле TUMAR кээ бир маалыматтарыңызды сактоого макул болосуз, кийинки жолу кызматты жакшыртуу үчүн.',
    place_order: 'Заказ берүү',
    registration: 'Катталуу',
  },
  ORDER_HISTORY: {
    order: 'Заказ',
    ordered: 'Буйрутма берилди',
    shipped: 'Жөнөтүлдү',
    expected_delivery: 'Жеткирүү күтүлүүдө',
    order_number: 'Заказ номери',
    date: 'Дата',
    total: 'Жалпы сумма',
    order_info: 'Заказ тууралуу маалымат',
    invoice: 'ЭСЕП-ФАКТУРА',
    retry: 'КАЙРА АРАКЕТТЕНҮҮ',
    payment_terminal: 'Төлөм терминалы',
    delivery_address: 'Жеткирүү дареги',
    order_table: ['Заказ', 'Дата', 'Статус', 'Жалпы', 'Аракеттер'],
    statuses: {
      [PROCESSING_ORDER_STATUS]: 'Иштеп жатат',
      [PAYMENT_WAITING_ORDER_STATUS]: 'Төлөм күтүлүүдө',
      [IN_PRODUCTION_ORDER_STATUS]: 'Өндүрүштө',
      [ON_HOLD_ORDER_STATUS]: 'Токтотулду',
      [COMPLETED_ORDER_STATUS]: 'Аяктады',
      [PACKAGING_ORDER_STATUS]: 'Таңгакталууда',
      [SHIPPING_ORDER_STATUS]: 'Жөнөтүлүүдө',
      [ON_WAY_ORDER_STATUS]: 'Жолдо',
    },
    complete: 'Заказ аяктады',
  },
  ORDER_COMPLEATE: {
    title: 'Go to order history',
    thanksTitle: 'Thanks. Your order has been accept.',
  },
  PRICE_LIST: {
    price: 'Price list',
    main: 'Main',
  },
  CART_FOOTER: {
    view: 'View Basket',
    ordering: 'Ordering',
    summary: 'Summary',
    basket: 'Basket',
    close: 'close',
  },
  ORDER_DETAILS: {
    account: 'Менин аккаунтум',
    order_details: 'Заказдын деталдары',
    title: 'ЗАКАЗДЫН ДЕТАЛДАРЫ',
    table: ['Сүрөт', 'Аталышы', 'Калдык', 'Аракеттер'],
    order_details_table: [
      '№',
      'Дата',
      'Продукт аты',
      'Колдонулган брендинг суммасы',
      'Учурдагы баланс',
    ],
  },
}
